import { Directive, ElementRef, HostListener, Input, OnDestroy } from '@angular/core';
import { ImageHoverPreviewService } from './image-hover-preview.service';

/**
 * Apply to any element that should reveal the shared image-hover preview popup on hover.
 *
 * Usage:
 *   <div imageHoverPreview
 *        [imageHoverPreviewSrc]="objectUrl"
 *        [imageHoverPreviewName]="item.name"
 *        [imageHoverPreviewVariant]="item.variant">
 *     <img [src]="objectUrl" />
 *   </div>
 *
 * Coordinates with `ImageHoverPreviewService` (singleton) and renders via
 * `ImageHoverViewerComponent` hosted somewhere in the active view.
 */
@Directive({
  selector: '[imageHoverPreview]'
})
export class ImageHoverPreviewDirective implements OnDestroy {

  @Input() imageHoverPreviewSrc?: string | null;
  @Input() imageHoverPreviewName?: string | null;
  @Input() imageHoverPreviewVariant?: string | null;

  private active = false;

  constructor(private el: ElementRef<HTMLElement>, private hoverService: ImageHoverPreviewService) { }

  @HostListener('mouseenter')
  onEnter(): void {
    if (!this.imageHoverPreviewSrc) return;
    this.active = true;
    this.hoverService.show({
      src: this.imageHoverPreviewSrc,
      name: this.imageHoverPreviewName ?? undefined,
      variant: this.imageHoverPreviewVariant ?? undefined,
      rect: this.el.nativeElement.getBoundingClientRect()
    });
  }

  @HostListener('mouseleave')
  onLeave(): void {
    if (!this.active) return;
    this.active = false;
    this.hoverService.hide();
  }

  ngOnDestroy(): void {
    if (this.active) this.hoverService.hide();
  }
}
